const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    userSelect: 'none',
    opacity: 0
  },
  item: {
    flex: '0 0 auto',
    display: 'block',
    margin: [0, 7],
    padding: 0,
    height: 22,
    fontSize: 22,
    lineHeight: '22px',
    textShadow: `0 0 5px ${theme.color.secondary.main}`,
    textAlign: 'center',
    color: theme.color.text.main,
    '&:hover': {
      color: theme.color.secondary.main
    }
  }
});

export { styles };
